import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import ApplicationHeader from "../application/ApplicationHeader";
import { Container } from "@mui/material";
import ApplicationPanel from "../application/ApplicationPanel";
import { createAppQueryClient } from "../application/queryClients";
import { AppQueryClientProvider } from "../application/AppQueryClientProvider";
import RipEndpointBrowse from "./RipEndpointBrowse";

const useStyles = makeStyles(theme => ({
  panel: {
    padding: 0,
  },

  creatorLogo: {
    width: "100%",
    height: "100%",
  },
}));

// Create a client
const queryClient = createAppQueryClient({
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: Infinity,
});

const ManageRipEndpoints = () => {
  const classes = useStyles();

  return (
    <Container id="manage-rip-endpoints" classes={{ root: classes.panel }}>
      <ApplicationHeader />

      <ApplicationPanel>
        <AppQueryClientProvider client={queryClient}>
          <RipEndpointBrowse />
        </AppQueryClientProvider>
      </ApplicationPanel>
    </Container>
  );
};

export default ManageRipEndpoints;
